/* AG filter bar (snippets/ag-filter-bar.liquid).
   The theme's filter-container re-renders .filters__inner after every change,
   which would snap an open dropdown shut after each tick. This remembers which
   groups were open and reopens them after the swap, keeps one dropdown open at
   a time on desktop, and closes it on an outside click or Escape. */
(function () {
  if (window.agFilterBarInit) return;
  window.agFilterBarInit = true;

  var openKeys = {};
  var desktop = window.matchMedia('(min-width: 1000px)');

  function groups(sel) {
    return Array.prototype.slice.call(document.querySelectorAll(sel || '.agf__group'));
  }

  function closeAll(except) {
    groups('.agf__group[open]').forEach(function (g) {
      if (g !== except) g.open = false;
    });
  }

  document.addEventListener('toggle', function (evt) {
    var g = evt.target;
    if (!g || !g.classList || !g.classList.contains('agf__group')) return;
    var key = g.getAttribute('data-agf-key');
    if (g.open) {
      if (desktop.matches) {
        openKeys = {};
        closeAll(g);
      }
      openKeys[key] = true;
    } else {
      delete openKeys[key];
    }
  }, true);

  document.addEventListener('click', function (evt) {
    if (!desktop.matches) return;
    if (evt.target.closest && evt.target.closest('.agf__group')) return;
    closeAll(null);
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Escape') return;
    var open = groups('.agf__group[open]');
    if (!open.length) return;
    closeAll(null);
    var summary = open[0].querySelector('summary');
    if (summary) summary.focus();
  });

  /* Reflect a tick straight away, before the refreshed markup arrives. */
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.closest) return;
    var opt = input.closest('.agf__opt, .agf__toggle');
    if (opt) opt.classList.toggle('is-on', input.checked);
    if (input.name === 'sort_by') {
      groups('.agf__sort-opt').forEach(function (o) {
        var r = o.querySelector('input');
        o.classList.toggle('is-on', !!(r && r.checked));
      });
    }
  });

  function restore() {
    groups().forEach(function (g) {
      if (openKeys[g.getAttribute('data-agf-key')]) g.open = true;
    });
  }

  function watch() {
    var inner = document.querySelector('.agf__inner');
    if (!inner || !window.MutationObserver) return;
    new MutationObserver(restore).observe(inner, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
